import { IframeMessageProxy } from 'iframe-message-proxy';
import IMPContainer from '../constants/iframe-message-proxy-container';

const MEDIA_URI = '/upload-media-uri'
const MEDIA_DOMAIN = 'postmaster@media.msging.net'

const getMediaUploadUrl = async () => {
    const { response } = await IframeMessageProxy.sendMessage({
        action: IMPContainer.Actions.SEND_COMMAND,
        content: {
            command: {
                method: IMPContainer.CommandMethods.GET,
                to: MEDIA_DOMAIN,
                uri: MEDIA_URI
            }
        }
    });
    console.log(response)
    return response;
};

export { getMediaUploadUrl };
